import { Dispatch, SetStateAction } from 'react'
import { useIntl } from 'react-intl'

import BaseModal from 'components/Modal/BaseModal'
import {
  DropzoneModalContainer,
  DropzoneModalTitle,
} from 'components/Modal/DropzoneModal/styles'
import { H2 } from 'components/Typography/Headings'
import TemplateDropZone from './TemplateDropZone'
import { templatesPageMessages } from 'features/templates/messages'

interface TemplateUploadModalProps {
  isOpen: boolean
  handleClose: () => void
  setUploadedFilename: Dispatch<SetStateAction<string>>
  onSuccess: () => void
}

function TemplateUploadModal({
  isOpen,
  handleClose,
  setUploadedFilename,
  onSuccess,
}: TemplateUploadModalProps) {
  const { formatMessage } = useIntl()

  return (
    <BaseModal isOpen={isOpen} onRequestClose={handleClose}>
      <DropzoneModalContainer>
        <DropzoneModalTitle>
          <H2>
            {formatMessage(templatesPageMessages.uploadTemplateModalTitle)}
          </H2>
        </DropzoneModalTitle>

        <TemplateDropZone
          setUploadedFilename={setUploadedFilename}
          onSuccess={onSuccess}
          handleClose={handleClose}
        />
      </DropzoneModalContainer>
    </BaseModal>
  )
}

export default TemplateUploadModal
